import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Project} from '../models/project';
import {Observable} from 'rxjs';
import {ProjectReference} from '../models/project-reference';
import {PageResponse} from '../models/page-response';
import {ProjectReferenceDetailResponse} from '../models/project-reference-detail.response';
import {ProjectReferenceSearchResponse} from '../models/project-reference-search-response';
import {SearchFacetGroupCollection} from '../models/search-facet';

export interface ProjectReferenceService {
    createReference(project: Project): Observable<ProjectReference>;
    updateReference(id: number, description: string): Observable<ProjectReferenceDetailResponse>;
    publishReference(id: number): Observable<void>;
    unpublishReference(id: number): Observable<void>;
    listReferences(search: string, filter: {[key: string]: (string|number)[]}, page: number): Observable<PageResponse<ProjectReferenceSearchResponse>>;
    detail(id: number): Observable<ProjectReferenceDetailResponse>;
    suggest(search: string): Observable<string[]>;
    getFacets(search: string): Observable<SearchFacetGroupCollection[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectReferenceServiceImpl implements ProjectReferenceService {
    protected http = inject(HttpClient);


    createReference(project: Project): Observable<ProjectReference> {
        return this.http.post<ProjectReference>(`/api/v1/project-references`, project);
    }

    updateReference(id: number, description: string): Observable<ProjectReferenceDetailResponse> {
        return this.http.put<ProjectReferenceDetailResponse>(`/api/v1/project-references/${id}`, {description});
    }

    publishReference(id: number): Observable<any> {
        return this.http.post(`/api/v1/project-references/${id}/publish`, null, {
            responseType: 'text'
        });
    }

    unpublishReference(id: number): Observable<any> {
        return this.http.post(`/api/v1/project-references/${id}/unpublish`, null, {
            responseType: 'text'
        })
    }

    listReferences(search: string, filter: {[key: string]: (string|number)[]}, page: number): Observable<PageResponse<ProjectReferenceSearchResponse>> {
        return this.http.get<PageResponse<ProjectReferenceSearchResponse>>(`/api/v1/project-references`, {
            params: {
                search,
                filter: JSON.stringify(filter),
                page: page.toString()
            }
        });
    }

    detail(id: number): Observable<ProjectReferenceDetailResponse> {
        return this.http.get<ProjectReferenceDetailResponse>(`/api/v1/project-references/${id}`);
    }

    suggest(search: string): Observable<string[]> {
        return this.http.get<string[]>(`/api/v1/project-references/suggest`, {
            params: {search}
        });
    }

    getFacets(search: string): Observable<SearchFacetGroupCollection[]> {
        return this.http.get<SearchFacetGroupCollection[]>(`/api/v1/project-references/facets`, {params: {search}});
    }
}
